import { useId, useState } from 'react';
import { AssetLinks } from '@assets/assets';
import { FieldWrapper, FieldWrapperPassThroughProps } from './FieldWrapper';

interface Option {
  value: string;
  label: string;
}

export type CustomSelectInputProps = React.SelectHTMLAttributes<HTMLSelectElement> &
  FieldWrapperPassThroughProps & {
    options: Option[];
    value: string;
    placeholder?: string;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  };

const CustomSelect: React.FC<CustomSelectInputProps> = ({
  options,
  name,
  value,
  disabled,
  onChange,
  onIconClick,
  label,
  placeholder = '',
  errorMessage,
  className = '',
}) => {
  const uniqueId = useId();
  const inputId = `custom-select-${uniqueId}`;
  const isPlaceholder = placeholder.length > 0;
  const [isFocused, setIsFocused] = useState(false);
  const shouldFloat = isFocused || Boolean(value && value.length > 0);

  return (
    <FieldWrapper
      label={label}
      errorMessage={errorMessage}
      float={true}
      isSelectFloat={shouldFloat}
      isPlaceholder={isPlaceholder}
      htmlFor={inputId}
      className={className}
      onIconClick={onIconClick}
    >
      <select
        name={name}
        value={value}
        disabled={disabled}
        id={inputId}
        className={`iLendingCDX-text-field__float iLendingCDX-custom-select ${
          errorMessage && 'iLendingCDX-text-field__float--error'
        }`}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onChange={onChange}
      >
        <option
          disabled
          hidden
          value=""
        ></option>
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>
      <span className="iLendingCDX-custom-select-marker">
        <img
          src={AssetLinks.selectMarker}
          alt=""
        />
      </span>
    </FieldWrapper>
  );
};

export default CustomSelect;
